import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { IoCopyOutline } from 'react-icons/io5';
import { copyToClipboard } from 'shared/helpers/clipboard';
import { R$ } from 'shared/helpers/currency';
import { Order, orderStatus } from 'shared/models/order';
import { PaymentMethods } from 'shared/types/payment';
import { useOrderModalContext } from '../ModalContext';

const OrderData = () => {
  const { order } = useOrderModalContext();

  const invoice = order?.invoice ?? null;

  const getStatusAndDate = (order: Order | undefined) => {
    const res = {
      status: '-',
      date: '-',
    };

    if (!order) return res;

    if (order.statusId === 2) {
      res.status = 'pagamento';
      res.date =
        order.complete_at != null
          ? order.complete_at.format('DD/MM/YYYY')
          : '-';
    }

    if (order.statusId === 4) {
      res.status = 'cancelamento';
      res.date =
        order.cancelled_at != null
          ? order.cancelled_at.format('DD/MM/YYYY')
          : '-';
    }

    return res;
  };

  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength)}...`;
  };

  return (
    <Stack>
      <Heading size="sm">Detalhes da Cobrança</Heading>
      <Flex wrap="wrap" rowGap="2rem" mt="1rem">
        <Box flexBasis="50%">
          <Text variant="label">Data de Vencimento</Text>
          <Text>{order?.due_date?.format('DD/MM/YYYY')}</Text>
        </Box>

        {order?.statusId !== orderStatus.EM_ABERTO && (
          <Box flexBasis="50%">
            <Text variant="label">
              Data de {getStatusAndDate(order)?.status}
            </Text>
            <Text>{getStatusAndDate(order)?.date}</Text>
          </Box>
        )}

        <Box flexBasis="50%">
          <Text variant="label">Valor</Text>
          <Text>{order?.priceString}</Text>
        </Box>

        {order?.bankId && (
          <Box flexBasis="50%">
            <Text variant="label">Método de pagamento</Text>
            <Text>{PaymentMethods[order.bankId]}</Text>
          </Box>
        )}

        <Box flexBasis="50%">
          <Text variant="label">Token</Text>
          <Button
            fontWeight="400"
            rightIcon={<IoCopyOutline />}
            variant="ghost"
            size="md"
            px="0"
            onClick={() => copyToClipboard(order?.token ?? '', 'Token copiado')}
            disabled={!order?.token}
          >
            {order?.token}
          </Button>
        </Box>

        {order?.bankId === 1 && (
          <Box flexBasis="50%">
            <Text variant="label">Parcelamento</Text>
            <Text>{order?.installments ?? '-'}</Text>
          </Box>
        )}
      </Flex>

      <Divider my={'1rem'}></Divider>

      {invoice?.is_active === 1 && (
        <>
          <Heading size="sm">Detalhes do boleto</Heading>
          <Flex wrap="wrap" rowGap="2rem" mt="1rem">
            <Box flexBasis="50%">
              <Text variant="label">Data de emissão</Text>
              <Text>{invoice.data_emissao.format('DD/MM/YYYY')}</Text>
            </Box>

            {Number(invoice.interest_amount) > 0 && (
              <Box flexBasis="50%">
                <Text variant="label">Valor pago de Juros</Text>
                <Text>{R$(invoice.interest_amount)}</Text>
              </Box>
            )}

            {Number(invoice.penalty_amount) > 0 && (
              <Box flexBasis="50%">
                <Text variant="label">Valor pago de Multa</Text>
                <Text>{R$(invoice.penalty_amount)}</Text>
              </Box>
            )}

            <Box flexBasis="33%">
              <Text variant="label">Código de barras</Text>
              <Button
                fontWeight="400"
                rightIcon={<IoCopyOutline />}
                variant="ghost"
                size="md"
                px="0"
                onClick={() =>
                  copyToClipboard(
                    invoice.linha_digitavel,
                    'Código de barras copiado',
                  )
                }
              >
                {invoice.linha_digitavel
                  ? truncateText(invoice.linha_digitavel, 40)
                  : 'Não disponível'}
              </Button>
            </Box>

            <Box flexBasis="33%">
              <Text variant="label">Pix Copia e Cola</Text>
              <Button
                fontWeight="400"
                rightIcon={<IoCopyOutline />}
                variant="ghost"
                size="md"
                px="0"
                onClick={() =>
                  copyToClipboard(invoice.qr_code_emv, 'Pix copiado')
                }
              >
                {invoice.qr_code_emv
                  ? truncateText(invoice.qr_code_emv, 40)
                  : 'Não disponível'}
              </Button>
            </Box>
          </Flex>
        </>
      )}
    </Stack>
  );
};

export default OrderData;
